import { useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { hasPermission } from '../utils/roles.helpers';

const SECTIONS = [
  {
    title: 'Accueil',
    links: [
      { to: '/dashboard',              label: 'Tableau de bord',       ico: '◆' },
      { to: '/communication/annonces', label: 'Annonces & actualités', ico: '📢', perm: 'annonces', module: 'communication' },
    ],
  },
  {
    title: 'Scolarité',
    links: [
      { to: '/eleves',              label: 'Élèves',             ico: '👨‍🎓', perm: 'eleves',         module: 'students' },
      { to: '/etablissement/admissions', label: 'Admissions',   ico: '✦',  perm: 'admissions',     module: 'admissions' },
      { to: '/presences',           label: 'Présences élèves',  ico: '✓',  perm: 'presences',      module: 'attendance' },
      { to: '/presences/rapports',  label: "Rapport d'absences",ico: '📊', perm: 'rapportAbsences', module: 'attendance' },
      { to: '/support/vie-scolaire',label: 'Vie scolaire',      ico: '◉',  perm: 'vieScolaire' },
      { to: '/support/sante',       label: 'Santé',             ico: '⊕',  perm: 'sante' },
      { to: '/support/formulaires', label: 'Formulaires admin.', ico: '□', perm: 'formulaires' },
    ],
  },
  {
    title: 'Pédagogie & Évaluations',
    links: [
      { to: '/pedagogie',                  label: 'Évaluations',        ico: '◎', perm: 'evaluations',    module: 'evaluations', exact: true },
      { to: '/pedagogie/bulletins',        label: 'Bulletins',          ico: '◆', perm: 'bulletins',      module: 'evaluations', hideForRoles: ['ENSEIGNANT'] },
      { to: '/pedagogie/cahier-texte',     label: 'Cahier de texte',    ico: '✎', perm: 'cahierTexte',    module: 'evaluations' },
      { to: '/pedagogie/validation-notes', label: 'Validation des notes',ico: '✓',perm: 'validationNotes',module: 'evaluations' },
      { to: '/pedagogie/classements',      label: 'Classements & moy.', ico: '🏆',perm: 'classements',   module: 'evaluations' },
      { to: '/pedagogie/rapports',         label: 'Rapports péda.',     ico: '📋',perm: 'rapportsPedago', module: 'evaluations' },
      { to: '/pedagogie/tableau-de-bord',  label: 'Tableau de bord',    ico: '📊',perm: 'evaluations',   module: 'evaluations', hideForRoles: ['ENSEIGNANT'] },
      { to: '/pedagogie/competences',      label: 'Compétences',        ico: '🎯',perm: 'evaluations',   module: 'competences' },
    ],
  },
  {
    title: 'Emploi du temps',
    links: [
      { to: '/emploi-du-temps',            label: 'Grille horaire',    ico: '⊞', perm: 'emploiDuTemps', module: 'timetable', exact: true },
      { to: '/emploi-du-temps/horaire',    label: 'Horaire des cours', ico: '◫', perm: 'emploiDuTemps', module: 'timetable' },
      { to: '/emploi-du-temps/calendrier', label: 'Calendrier acad.',  ico: '📅', perm: 'emploiDuTemps', module: 'timetable' },
      { to: '/emploi-du-temps/publication',label: 'Publication',       ico: '📣', perm: 'emploiDuTemps', module: 'timetable', hideForRoles: ['ENSEIGNANT'] },
      { to: '/emploi-du-temps/parametres', label: 'Paramètres EDT',    ico: '⚙', perm: 'emploiDuTemps', module: 'timetable', hideForRoles: ['ENSEIGNANT'] },
    ],
  },
  {
    title: 'Finance',
    links: [
      { to: '/finance',                          label: 'Recouvrement',               ico: '💰', perm: 'finance',   module: 'finance', exact: true },
      { to: '/finance/factures-inscription',     label: 'Règlement Facture inscription', ico: '🧾', perm: 'finance', module: 'finance' },
      { to: '/finance/paiements',                label: 'Gestion paiements',          ico: '💳', perm: 'paiements', module: 'finance' },
      { to: '/finance/tresorerie',               label: 'Trésorerie',                 ico: '🏦', perm: 'tresorerie',module: 'finance' },
      { to: '/finance/frais',                    label: 'Frais & facturation',        ico: '🧮', perm: 'finance',   module: 'finance' },
    ],
  },
  {
    title: 'Ressources humaines',
    links: [
      { to: '/communication/personnel',           label: 'Personnel',         ico: '👨‍🏫', perm: 'personnel',         module: 'staff' },
      { to: '/portail-enseignant',                label: 'Portail enseignant',ico: '✎',   perm: 'portailEnseignant', module: 'staff' },
      { to: '/communication/presences-personnel', label: 'Présences pers.',   ico: '✓',   perm: 'personnel',         module: 'staff' },
      { to: '/communication/contrats',            label: 'Contrats',          ico: '📋',  perm: 'contrats',          module: 'hr' },
      { to: '/communication/conges',              label: 'Congés & absences', ico: '✈',   perm: 'conges',            module: 'hr' },
      { to: '/communication/registre',            label: 'Registre employeur',ico: '📁',  perm: 'personnel',         module: 'registry' },
    ],
  },
  {
    title: 'Bibliothèque',
    links: [
      { to: '/bibliotheque',           label: 'Catalogue',  ico: '📚', perm: 'bibliotheque', module: 'library', exact: true },
      { to: '/bibliotheque/emprunts',  label: 'Emprunts',   ico: '◫',  perm: 'bibliotheque', module: 'library' },
      { to: '/bibliotheque/retards',   label: 'Retards',    ico: '⚠',  perm: 'bibliotheque', module: 'library' },
      { to: '/bibliotheque/historique',label: 'Historique', ico: '◉',  perm: 'bibliotheque', module: 'library' },
    ],
  },
  {
    title: 'Logistique & Stocks',
    links: [
      { to: '/finance/stocks',      label: 'Stocks & fournitures',  ico: '⊞', perm: 'stocks', module: 'assets' },
      { to: '/finance/fournisseurs',label: 'Fournisseurs',          ico: '◈', perm: 'stocks', module: 'assets' },
      { to: '/support/materiel',    label: 'Équipement & matériel', ico: '⚙', perm: 'stocks', module: 'assets' },
      { to: '/support/salles',      label: 'Salles de classe',       ico: '⊞', perm: 'stocks', module: 'assets' },
    ],
  },
  {
    title: 'Communication',
    links: [
      { to: '/communication', label: 'Messagerie & SMS', ico: '✉', perm: 'communication', module: 'communication', exact: true },
    ],
  },
  {
    title: 'Établissement & Gouvernance',
    links: [
      { to: '/etablissement',           label: 'Fiche établissement',  ico: '🏫', perm: 'etablissement', module: 'school', exact: true },
      { to: '/etablissement/structure', label: 'Structure académique', ico: '⊞', perm: 'structure',     module: 'structure' },
      { to: '/admin/roles',             label: 'Gestion des rôles',   ico: '🔐', perm: 'gestionRoles',  module: 'users' },
    ],
  },
];

const PARENT_SECTIONS = [
  {
    title: 'Mon espace',
    links: [
      { to: '/dashboard',              label: 'Mes enfants',  ico: '👨‍👩‍👧' },
      { to: '/communication/annonces', label: 'Annonces',     ico: '📢' },
    ],
  },
];

const PLATFORM_SECTION = {
  title: 'Plateforme',
  links: [
    { to: '/plateforme',             label: 'Vue d\'ensemble',    ico: '⚙',  exact: true },
    { to: '/plateforme/ecoles',      label: 'Écoles clientes',    ico: '🏫' },
    { to: '/plateforme/plans',       label: 'Plans',              ico: '◆' },
    { to: '/plateforme/abonnements', label: 'Abonnements',        ico: '💳' },
    { to: '/plateforme/facturation', label: 'Facturation',        ico: '🧾' },
    { to: '/plateforme/support',     label: 'Support',            ico: '⊕' },
    { to: '/plateforme/supervision', label: 'Supervision',        ico: '◉' },
    { to: '/plateforme/securite',    label: 'Sécurité',           ico: '🔐' },
    { to: '/plateforme/configuration',label: 'Configuration',     ico: '⚙' },
    { to: '/plateforme/marketing',   label: 'Marketing',          ico: '📣' },
    { to: '/plateforme/analytique',  label: 'Analytique',         ico: '📊' },
  ],
};

export default function Sidebar() {
  const { user, logout, perms } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [openSections, setOpenSections] = useState({});
  const isSuperAdmin = (user?.roles || []).includes('SUPER_ADMIN');
  const userRoles    = user?.roles || [];
  const STAFF_ROLES  = ['SUPER_ADMIN','ADMINISTRATEUR','PROVISEUR','CENSEUR','SECRETAIRE','COMPTABLE','SURVEILLANT','ENSEIGNANT'];
  const isParent     = userRoles.includes('PARENT') && !userRoles.some(r => STAFF_ROLES.includes(r));

  const ROLE_PRIORITY = ['SUPER_ADMIN','ADMINISTRATEUR','PROVISEUR','CENSEUR','SECRETAIRE','COMPTABLE','SURVEILLANT','ENSEIGNANT','PARENT'];
  const displayRole   = ROLE_PRIORITY.find(r => userRoles.includes(r)) || userRoles[0] || '';

  const allSections = isSuperAdmin ? [PLATFORM_SECTION, ...SECTIONS] : SECTIONS;
  const finalSections = isParent ? PARENT_SECTIONS : allSections;

  function toggleSection(title) {
    setOpenSections((prev) => ({ ...prev, [title]: !prev[title] }));
  }

  function isOpen(title) {
    if (title in openSections) return openSections[title];
    // Ouvrir automatiquement si un lien actif est dedans
    return finalSections.find((s) => s.title === title)?.links.some((l) => pathname.startsWith(l.to)) ?? false;
  }

  const initials = ((user?.firstName?.[0] || '') + (user?.lastName?.[0] || '')).toUpperCase() || 'U';

  return (
    <aside className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      {/* Logo */}
      <div className="sidebar-logo">
        <div className="mark">S</div>
        {!collapsed && <div><div className="name">Schoolizy</div><div className="tenant">La Providence</div></div>}
      </div>

      {/* User */}
      <div className="sidebar-user">
        <div className="avatar">{initials}</div>
        {!collapsed && (
          <div>
            <div className="uname">{user?.firstName} {user?.lastName}</div>
            <div className="urole">{displayRole.replace(/_/g, ' ')}</div>
          </div>
        )}
      </div>

      {/* Nav */}
      <nav className="sidebar-nav">
        {finalSections.map((sec) => {
          const visibleLinks = sec.links.filter((l) => {
            if (l.hideForRoles && l.hideForRoles.some((r) => userRoles.includes(r))) return false;
            if (!l.perm) return true;
            if (isSuperAdmin) return true;
            if (l.module && perms && l.module in perms) return perms[l.module];
            return hasPermission(userRoles, l.perm);
          });
          if (visibleLinks.length === 0) return null;

          return (
            <div key={sec.title}>
              {!collapsed && (
                <button className="nav-section-title" style={{ background: 'none', border: 'none', cursor: 'pointer', width: '100%', textAlign: 'left', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                  onClick={() => toggleSection(sec.title)}>
                  {sec.title}
                  <span style={{ fontSize: 8, opacity: .5 }}>{isOpen(sec.title) ? '▼' : '▶'}</span>
                </button>
              )}
              {(collapsed || isOpen(sec.title)) && visibleLinks.map((link) => {
                return (
                  <NavLink key={link.to} to={link.to} end={!!link.exact} className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                    <span className="nav-ico">{link.ico}</span>
                    {!collapsed && link.label}
                  </NavLink>
                );
              })}
            </div>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="sidebar-footer">
        <button className="sidebar-toggle" onClick={() => setCollapsed(!collapsed)}>
          {collapsed ? '→' : '← Réduire'}
        </button>
      </div>
    </aside>
  );
}
